import { CharacterType } from "@next-platform/packages-ts-types";

import { NSFW_TAGS, ROUTES, TAGS_TO_EXCLUDE } from "@/constants";
import { Collection } from "@/types/api";

interface ICreateFiltersProps {
  applicationId?: string;
  charactersList?: string[];
  username?: string;
  isPartner?: boolean;
  shouldFilterNsfwCharacters?: boolean;
  pagePath: string;
  foundNegativeKeyword: boolean;
  blockedUsers?: string[];
  defaultTag?: string;
  collection?: Collection;
  characterType?: CharacterType;
}

const createFilters = ({
  applicationId,
  charactersList = [],
  username,
  isPartner,
  shouldFilterNsfwCharacters,
  pagePath,
  foundNegativeKeyword,
  blockedUsers = [],
  defaultTag,
  collection = Collection.CHARACTERS,
  characterType,
}: ICreateFiltersProps) => {
  const filters = [];
  const isCharactersCollection = collection === Collection.CHARACTERS;
  const isLorebooksCollection = collection === Collection.LOREBOOKS;

  if (applicationId) {
    filters.push(`application_ids:${applicationId}`);
  }
  if (charactersList.length > 0) {
    let keyId = "character_id";
    if (isLorebooksCollection) {
      keyId = "lorebook_id";
    }
    filters.push(`${keyId}:[${charactersList.map((id: string) => `'${id}'`).join(",")}]`);
  }
  if (username) {
    filters.push(`creator_username:${username}`);
  }

  const tagsToFilter = [];

  if (!isPartner && isCharactersCollection) {
    tagsToFilter.push(TAGS_TO_EXCLUDE.STEP_FAMILY);
  }

  // Filter NSFW tags in SFW mode for public character and lorebook browsing.
  if (shouldFilterNsfwCharacters) {
    tagsToFilter.push(...NSFW_TAGS);
  }

  if (tagsToFilter.length > 0) {
    filters.push(`tags:![${tagsToFilter.join(",")}]`);
  }

  if (shouldFilterNsfwCharacters) {
    filters.push(`is_nsfw:false`);
  }

  if (characterType && isCharactersCollection) {
    filters.push(`type:${characterType}`);
  }

  const isFavoritesCharactersPage = pagePath === ROUTES.favoriteBots || pagePath === ROUTES.favoritesGroups;

  if (isCharactersCollection && ((!charactersList.length && isFavoritesCharactersPage) || foundNegativeKeyword)) {
    filters.push(`character_id:null`);
  }

  /**
   * When user tries to navigate to some bot creator's page, we get username in props.
   * And blocked creator object is always present since it's stored globally in redux.
   * Thus to render creator page for a blocked creator, we need username check below.
   */
  if (blockedUsers?.length && !username) {
    filters.push(`creator_user_id:![${blockedUsers.map((id: string) => `'${id}'`).join(",")}]`);
  }

  if (defaultTag) {
    filters.push(`tags:=[\`${defaultTag}\`]`);
  }

  return filters.join(" && ");
};

export default createFilters;
